import { Component, Input, ContentChild, ElementRef, AfterContentInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DEFAULT_INFOTEXT_CONFIG, InfoTextConfig } from './info-text.modal';

@Component({
  selector: 'ds-info-text',
  templateUrl: './info-text.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class InfoTextComponent implements AfterContentInit {
  public _infoTextInput: InfoTextConfig = { ...DEFAULT_INFOTEXT_CONFIG };
  @Input() infoTextInput!: InfoTextConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.infoTextInput) {
      const val: InfoTextConfig = changes.infoTextInput.currentValue || {};
      this.infoTextInput = { ...DEFAULT_INFOTEXT_CONFIG, ...val };
    }
  }

  // ContentChild to detect whether an icon has been projected into [info-icon]
  @ContentChild('[info-icon]', { read: ElementRef }) projectedIcon?: ElementRef;
  hasProjectedIcon = false;

  ngAfterContentInit(): void {
    this.hasProjectedIcon = !!this.projectedIcon;
  }
}
